import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  rem,
  TextInput,
  Title,
} from "@mantine/core";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import {
  IconBriefcase,
  IconFileExport,
  IconFolders,
  IconListDetails,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  keySearchMIIR,
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { changeSearchValue } from "../../../../_base/helper/FunctionHelper";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const MachineInstallationInventoryReport = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const _searchJson = localStorage.getItem(keySearchMIIR)
    ? JSON.parse(localStorage.getItem(keySearchMIIR) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [search, setSearch] = useState<any>({});
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataCatSegment2b, setDataCatSegment2b] = useState<ComboboxItem[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);

  const [search4d, setSearch4d] = useState<string>("");
  const [debounceSearch4d] = useDebouncedValue<string>(search4d, 500);
  const [search5e, setSearch5e] = useState<string>("");
  const [debounceSearch5e] = useDebouncedValue<string>(search5e, 500);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maVt",
        header: "Mã vật tư",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "tenVt",
        header: "Tên vật tư",
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "maChung",
        header: "Mã chủng",
      },
      {
        accessorKey: "tenChung",
        header: "Tên chủng",
      },
      {
        accessorKey: "maNhom",
        header: "Mã nhóm",
      },
      {
        accessorKey: "tenNhom",
        header: "Tên nhóm",
      },
      {
        accessorKey: "maNganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "tenNganh",
        header: "Tên ngành",
      },
      {
        accessorKey: "inventoryCode",
        header: "Mã kho",
      },
      {
        accessorKey: "ton101",
        header: "01_Hai Bà Trưng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton102",
        header: "02_Đống Đa",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton103",
        header: "03_Hải Phòng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton104",
        header: "04_Cầu Giấy",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton105",
        header: "05_Hà Đông 1",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton106",
        header: "06_Long Biên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton107",
        header: "07_Đông Anh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton108",
        header: "08_Hà Đông 2",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton109",
        header: "09_Bắc Giang",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton110",
        header: "10_Phủ Lý",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton111",
        header: "11_Vinh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton112",
        header: "12_Thái Nguyên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton113",
        header: "13_Thanh Hóa",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton114",
        header: "14_Hoàng Mai",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton115",
        header: "15_Kho HUB",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton116",
        header: "16_Cầu Giấy 2",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton117",
        header: "17_Ocean Park",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton121",
        header: "21_Q3-HCM",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton122",
        header: "22_Từ Sơn",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton123",
        header: "23_Thanh Trì",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton131",
        header: "31_Dịch Vụ Tốt Thái Hà",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ton132",
        header: "32_Dịch Vụ Tốt Cầu Giấy",
        size: 225,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        header: "Tổng số lượng",
        accessorKey: "totalQuantity",
        Cell: ({ row }) => {
          const tonKeys = [
            "ton101",
            "ton102",
            "ton103",
            "ton104",
            "ton105",
            "ton106",
            "ton107",
            "ton108",
            "ton109",
            "ton110",
            "ton111",
            "ton112",
            "ton113",
            "ton114",
            "ton115",
            "ton116",
            "ton117",
            "ton121",
            "ton122",
            "ton123",
            "ton131",
            "ton132",
          ];

          if (!row.original || typeof row.original !== "object") {
            console.error("Lỗi: row.original không hợp lệ!", row.original);
            return <>0</>;
          }

          const totalQuantity = tonKeys.reduce((acc, key) => {
            const value = (row.original as any)[key];
            return acc + (typeof value === "number" ? value : 0);
          }, 0);

          return <>{totalQuantity}</>;
        },
      },
    ],
    []
  );

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/VInventorySerialOnhandByBranchLmRp/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      localStorage.setItem(
        keySearchMIIR,
        JSON.stringify({ ...search, keySearch: keySearch })
      );
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/ExportExcel/export-bao-cao-ton-kho-lap-may${url}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_ton_kho_lap_may.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const getCatSegment2b = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment2b/get-all"
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment2b(data);
    }
  };

  const getCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;

    if (debounceSearch4d.length > 3 && search?.MaChungs?.length === 0) {
      url += `&KeySearch=${debounceSearch4d}`;
    } else {
      url += `&KeySearch=${debounceSearch4d?.split(" - ")[0]}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment4d(data);
    }
  };

  const getCatSegment5e = async () => {
    let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;

    if (search?.MaChungs && search?.MaChungs?.length > 0) {
      url += `&ListCodeString4=${search?.MaChungs}`;
    }

    if (debounceSearch5e.length > 3) {
      url += `&KeySearch=${debounceSearch5e}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment5e(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    getCatSegment2b();
  }, []);

  useEffect(() => {
    getCatSegment4d();
  }, [debounceSearch4d]);

  useEffect(() => {
    getCatSegment5e();
  }, [search.MaChungs, debounceSearch5e]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem("columnPinningMIIR");
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["mrt-row-numbers", "maVt"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem("columnPinningMIIR", JSON.stringify(columnPinning));
  }, [columnPinning]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (140 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã ngành"
              data={dataCatSegment2b}
              leftSection={<IconBriefcase color="#15aabf" />}
              searchable
              clearable
              value={
                search?.MaNganhs && search?.MaNganhs?.length > 0
                  ? search?.MaNganhs
                  : []
              }
              onChange={(e) => {
                changeSearchValue(e ? e : [], "MaNganhs", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã chủng"
              data={dataCatSegment4d}
              leftSection={<IconListDetails color="#15aabf" />}
              searchable
              searchValue={search4d}
              onSearchChange={setSearch4d}
              clearable
              value={
                search?.MaChungs && search?.MaChungs?.length > 0
                  ? search?.MaChungs
                  : []
              }
              onChange={(e) => {
                changeSearchValue(e ? e : [], "MaChungs", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã nhóm"
              data={dataCatSegment5e}
              leftSection={<IconFolders color="#15aabf" />}
              searchable
              searchValue={search5e}
              onSearchChange={setSearch5e}
              clearable
              value={
                search?.MaNhoms && search?.MaNhoms?.length > 0
                  ? search?.MaNhoms
                  : []
              }
              onChange={(e) => {
                changeSearchValue(e ? e : [], "MaNhoms", setSearch);
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default MachineInstallationInventoryReport;
